import {MetaTitleDesc} from "../meta";
import DocumentMeta from "react-document-meta";

export default () => {
    const title = 'Тепловоз М62 1003';

    return (
        <>
            <DocumentMeta {...MetaTitleDesc(title, title)} />

            <div id="content">
                <div className="pageitem">
                    <h2>{title}</h2>
                    <p>Типа М62 №1003</p>
                    <p>Построен в 1970 году на Луганском тепловозостроительном заводе</p>
                    <p>Тип грузовой, односекционный, с двумя кабинами машиниста Конструктивная скорость - 100 км/ч</p>
                    <p>Служебный вес - 116,5т</p>
                    <p>Мощность - 2000 л.с.</p>
                    <p>Нагрузка на ось - 19,4т</p>
                    <p>Лёгкий тепловоз для экспорта в страны СЭВ. Первым заказчиком была Венгрия, поэтому два прототипа, испытывавшиеся на железных дорогах СССР, получили венгерское обозначение М62. Всего в 1965-1988 гг. было поставлено 2546 экспортных экземпляров этого тепловоза, а с 1970 года поставлялись и на советские железные дороги. При этом вместо запланированной серии ТЭ112 была оставлена серия М62 (в документации иногда - М62С). Эти тепловозы использовались в качестве вывозных и лёгких пассажирских. Позже они послужили основой для создания усовершенствованных двухсекционных, трёхсекционных и промышленных локомотивов.</p>
                </div>
                <div className="three-col-cell gallery"><img src={require('./../img/virtualtours/museumlocomotive/mzt065.jpg')} /></div>
            </div>
        </>
    );
}